// WithdrawalApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'Withdrawal'];

// Enhance the base API service by adding entication-related tag types
const WithdrawalApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      // Create a new 
        createWithdrawal: build.mutation({
            query: ({ Withdrawal, user_id }) => ({
              url: `/withdrawals/${user_id}`,
              method: 'POST',
              data: Withdrawal,  // Using ShopProfile interface data here
            }),
            invalidatesTags: ['Withdrawal'],  // Invalidate ShopProfiles tags after creation
          }),
      // Fetch Withdrawal query (GET request to /me)
      getWithdrawal: build.query({
        query: (userId) => ({
          url: `/withdrawals/user/${userId}`,
        }),
        providesTags: ['Withdrawal'],
      }),  
      
       // Delete   mutation (DELETE request  )
       deleteWithdrawal: build.mutation({
        query: (id) => ({
          url: `/withdrawals/${id}`,
          method: 'DELETE',
        }),
        invalidatesTags: ['Withdrawal'], // Invalidate the user tag after deletion
      }),
    }),
    overrideExisting: false,
  });

export default WithdrawalApi;

// Exporting hooks for each endpoint to be used in components
export const {
    useCreateWithdrawalMutation,
   useGetWithdrawalQuery,
   useDeleteWithdrawalMutation,
} = WithdrawalApi;


